import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What are rights granted by you?</div>
        <p>
          By submitting an entry into this Giveaway,You understand and agree
          that the Sponsor, any individual acting on the Sponsor’s behalf, and
          the licensees successors, and assigns of the Sponsor shall, where
          permitted by law, have the right to print,publish, broadcast,
          distribute and use in any media known now or hereafter developed, in
          perpetuity, worldwide, and without limitation, your submission, name,
          photo, portrait, voice, likeness, image, statements about the T-Shirt
          Giveaway, and your biographical information for news, publicity,
          advertising, promotional purposes,trade, information, and public
          relations without any further notice,review, consent, compensation, or
          remuneration.
        </p>
      </div>
    </div>
  );
};

export default Q2;
